import { get, post, put, del } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  getWines: async params => {
    const options = { url: apiEndpoints.wines, params: { ...params } };
    return get(options);
  },
  getWineLibraryProducerOptions: async () => {
    const options = { url: apiEndpoints.wineLibraryProducers };
    return get(options);
  },
  getWineLibraryCountryOptions: async () => {
    const options = { url: apiEndpoints.wineLibraryCountries };
    return get(options);
  },
  getWineLibraryRegionOptions: async () => {
    const options = { url: apiEndpoints.wineLibraryRegions };
    return get(options);
  },
  getWineLibraryTypeOptions: async () => {
    const options = { url: apiEndpoints.wineLibraryTypes };
    return get(options);
  },
  getWine: async id => {
    const options = { url: apiEndpoints.wine.replace(':id', id) };
    return get(options);
  },
  createWine: async data => {
    const options = { url: apiEndpoints.wines, data };
    return post(options);
  },
  deleteWineMany: async data => {
    const options = { url: apiEndpoints.wines, data };
    return del(options);
  },
  updateWine: async (data, id) => {
    const options = { url: apiEndpoints.wine.replace(':id', id), data };
    return put(options);
  },
  importWines: async (file, serviceProviderId) => {
    const data = new FormData();
    data.append('file', file);
    if (serviceProviderId) {
      data.append('serviceProviderId', serviceProviderId);
    }
    const options = {
      url: apiEndpoints.winesImport,
      data,
      headers: {
        'Content-type': 'multipart/form-data',
      },
    };
    return post(options);
  },
  copyToWines: async data => {
    const options = { url: apiEndpoints.copyToWines, data };
    return post(options);
  },
  getWineCount: async params => {
    const options = {
      url: apiEndpoints.getWineCount,
      params: { ...params },
    };
    return get(options);
  },
};
